// extracted by mini-css-extract-plugin
export default {"wrapper":"Iea-z","play":"Jea-z"};